var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{staticClass:"room",attrs:{"src":require(`@/assets/mishi/room${_vm.pic}.jpg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }